import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class BigdesCurrentSituationEvaluationScopeService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getScope() {
        try {
            const response = await withRetry(() => this.api.getScope(), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch current situation evaluation scope');
        }
    }

    async updateScope(payload) {
        try {
            const response = await withRetry(() => this.api.updateScope(payload), { maxRetries: 2 });
            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to update current situation evaluation scope');
        }
    }

    _handleError(error, fallbackMessage) {
        if (error instanceof ApiError) return error;
        return new ApiError(fallbackMessage, error?.response?.status || 500, error?.response?.data);
    }
}
